import { createAction, handleActions } from "redux-actions";

const actionScope = "TRIAL_SESSION_";

export const trialSessionRequestFail = createAction(actionScope + "TRIAL_SESSION_REQUEST_FAIL");

export const loadTrialsRequest = createAction(actionScope + "LOAD_TRIALS_REQUEST");
export const loadTrialsSuccess = createAction(actionScope + "LOAD_TRIALS_SUCCESS");

// export const updateTrialRequest = createAction(actionScope + "UPDATE_TRIAL_REQUEST");
// export const updateTrialSuccess = createAction(actionScope + "UPDATE_TRIAL_SUCCESS");

// export const deleteTrialRequest = createAction(actionScope + "DELETE_TRIAL_REQUEST");
// export const deleteTrialSuccess = createAction(actionScope + "DELETE_TRIAL_SUCCESS");

export const setCurrentTrialRequest = createAction(actionScope + "SET_CURRENT_TRIAL_REQUEST");
export const setCurrentTrialSuccess = createAction(actionScope + "SET_CURRENT_TRIAL_SUCCESS");

//selectors
// export const practiceODMsSelector = state => state.practices;

// initial state
const initialState = {
  trials: null,
  currentTrial: null,
};

// reducers
export default handleActions(
  {
    [trialSessionRequestFail]: state => state,

    [loadTrialsRequest]: state => state,
    [loadTrialsSuccess]: (state, { payload }) => ({
      ...state,
      trials: payload,
    }),

    // [updateTrialRequest]: state => state,
    // [updateTrialSuccess]: (state, { payload }) => ({
    //   ...state,
    //   practices: payload,
    // }),

    // [deleteTrialRequest]: state => state,
    // [deleteTrialSuccess]: (state, { payload }) => ({
    //   ...state,
    //   practices: payload,
    // }),

    [setCurrentTrialRequest]: state => state,
    [setCurrentTrialSuccess]: (state, { payload }) => ({
      ...state,
      currentTrial: payload,
    }),
  },
  initialState
);
